import React from 'react';
import { content } from '../data/content';
import { ArrowDown, ChevronDown } from 'lucide-react';

const CoreValue: React.FC = () => {
  const { about } = content;

  // Gradient text style with more vibrant colors
  const gradientTextClass = "text-4xl md:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 via-violet-600 to-fuchsia-600 drop-shadow-sm py-2";
  const connectorClass = "text-gray-400 font-medium text-sm md:text-base flex flex-col items-center gap-2 py-4";

  return (
    <section className="min-h-screen flex items-center justify-center py-16 bg-white relative overflow-hidden">
      {/* Spotlight Effect - Light Theme */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[500px] bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-primary-100/60 via-white/0 to-transparent pointer-events-none"></div>
      
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary-50/50 rounded-full blur-3xl transform translate-x-1/3 -translate-y-1/3 animate-pulse"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-accent-50/50 rounded-full blur-3xl transform -translate-x-1/3 translate-y-1/3 animate-pulse delay-1000"></div>
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-10 mix-blend-multiply"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center justify-center h-16 w-16 bg-white shadow-lg rounded-2xl mb-6 border border-gray-100 animate-fade-in-up hover:scale-110 transition-transform duration-500">
            <svg className="w-8 h-8 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path></svg>
          </div>
          
          <h2 className="text-base md:text-lg font-bold text-primary-600 uppercase tracking-[0.3em] mb-12 animate-fade-in-up delay-100">
            {about.coreValue.title}
          </h2>
          
          <div className="flex flex-col items-center animate-fade-in-up delay-200">
            {/* Intro */}
            <p className="text-xl text-gray-500 font-medium mb-8">帮助个人及团队</p>
            
            {/* Step 1 */}
            <div className={gradientTextClass}>零散输出</div>
            
            {/* Connector */}
            <div className={connectorClass}>
              <div className="h-8 w-px bg-gradient-to-b from-gray-200 to-primary-200"></div>
              <span className="bg-white px-3 py-1 rounded-full border border-gray-100 shadow-sm text-primary-600 text-xs tracking-widest uppercase">走向</span>
              <ChevronDown size={20} className="text-primary-400 animate-bounce" />
            </div>
            
            {/* Step 2 */}
            <div className={gradientTextClass}>体系化运营</div>
            
            {/* Connector */}
            <div className={connectorClass}>
              <div className="h-8 w-px bg-gradient-to-b from-gray-200 to-primary-200"></div>
              <span className="bg-white px-3 py-1 rounded-full border border-gray-100 shadow-sm text-primary-600 text-xs tracking-widest uppercase">实现</span>
              <ChevronDown size={20} className="text-primary-400 animate-bounce delay-100" />
            </div>
            
            {/* Step 3 */}
            <div className={gradientTextClass}>持续沉淀信任</div>
            
            {/* Connector */}
            <div className={connectorClass}>
              <ArrowDown size={24} className="text-primary-300" />
            </div>
            
            {/* Step 4 */}
            <div className={gradientTextClass}>高质量咨询</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoreValue;